import { garageLocatorData } from '../../quote-tool/modules/garageLocator';
import { userInfoData } from '../../quote-tool/modules/userInfo';
import { dateSelectorData, formatTime } from '../../quote-tool/modules/dateSelector';
import { replacementData } from '../../quote-tool/modules/replacements';
import { vehicleSelectorData } from './vehicleSelector';
import { applyData, checkAreSubmitPassed, convertDate } from '../../quote-tool/modules/summary';
import { serviceSelectorData } from './serviceSelector';
import toolLoader from '../components/toolLoader';
import { apSwitchStep } from '../components/apSwitchStep';
import { menaPrice } from '../../components/tools';
import apAnalytics from '../components/apAnalytics';

const $ = jQuery;
const $appointmentToolContainer = $('#appointment-tool');

/**
 * Summary module
 */
export function summaryModule() {
    submitModule();
}

/**
 * Generate summary
 */
export function generateSummary() {
    const garageInfo = `<span>${garageLocatorData.name}</span>
                        <span>${garageLocatorData.address}</span>
                        <span>${garageLocatorData.phone}</span>`;

    const userInfo = `<span>${userInfoData.lastname} ${userInfoData.firstname}</span>
                      <span style="text-transform: none">${userInfoData.email}</span>
                      <span>${userInfoData.phone}</span>`;

    const dateInfo = `<span>${convertDate(dateSelectorData.fullDate)}</span>
                      <span>${formatTime(dateSelectorData.time)}</span>`;

    let services = '';
    serviceSelectorData.items.forEach((item) => {
        services += `<span>${item.name}</span>`;
    });
    applyData(services, 'service');

    let totalPrice;
    if (replacementData.price) {
        totalPrice = serviceSelectorData.totalPrice + replacementData.price;
    } else {
        totalPrice = serviceSelectorData.totalPrice;
    }

    console.log(totalPrice);

    applyData(replacementData.type, 'replacement');
    applyData(menaPrice(totalPrice), 'total-price');
    applyData(garageInfo, 'garage');

    const marque = vehicleSelectorData.marqueText;
    const model = vehicleSelectorData.modelText;
    let vehicle;
    if (model.includes(marque)) {
        vehicle = model;
    } else {
        vehicle = `${marque} ${model}`;
    }
    applyData(vehicle, 'vehicle');
    applyData(vehicleSelectorData.chassisNumber, 'vin');
    applyData(vehicleSelectorData.licensePlate, 'license_plate');
    applyData(vehicleSelectorData.mileage, 'license_km');

    applyData(userInfo, 'about');
    applyData(userInfoData.contactPreferenceText, 'contact_preference');
    applyData(dateInfo, 'date');
}

function submitModule() {
    $appointmentToolContainer.on('click', '.js-qt-summary--submit', function () {
        const comment = $('#summary-comment').val();
        let language = $('body').attr('data-lang-slug');
        if (!language) {
            language = 'fr';
        }
        language = language.toUpperCase();

        const data = {
            Assets: {
                Brand: vehicleSelectorData.marqueText,
                LicensePlate: vehicleSelectorData.licensePlate,
                Model: vehicleSelectorData.modelText,
                VIN: vehicleSelectorData.chassisNumber,
                Mileage: vehicleSelectorData.mileage,
            },
            Comments: comment,
            Contact: {
                Email: userInfoData.email,
                Name: userInfoData.firstname + ' ' + userInfoData.lastname,
                ContactPreference: userInfoData.contactPreference.toUpperCase(),
                Comments: 'Phone: ' + userInfoData.phone,
                Language: language,
                NonGdpr: !userInfoData.marketingConsent, // true if user did NOT give consent
            },
            PlanCodes: [],
            DepartmentId: parseInt(garageLocatorData.departmentID),
            TimeslotId: dateSelectorData.slotId,
            TotalPrice: serviceSelectorData.totalPrice + replacementData.price,
        };

        if (vehicleSelectorData.mileage) {
            let mileage = vehicleSelectorData.mileage;

            if (!isNaN(mileage)) {
                mileage = 0;
            }

            if (mileage > 9999999) {
                mileage = 0;
            }

            data.Assets.Mileage = mileage;
        }

        let replacementSlug = 'NONE';
        if (replacementData.slug) {
            replacementSlug = replacementData.slug;
        }
        data.Service = replacementSlug;

        // Add services
        serviceSelectorData.items.forEach((item) => {
            data.PlanCodes.push({
                Duration: item.duration,
                ExternalId: item.apiId,
            });
        });

        $.ajax({
            type: 'POST',
            url: menaObject.ajaxurl,
            dataType: 'html',
            data: {
                action: 'qtCreateOrder',
                data: data,
                garageID: garageLocatorData.garageID,
            },
            beforeSend: function () {
                toolLoader();
            },
            success: function (response) {
                const passed = checkAreSubmitPassed(response);

                if (passed) {
                    apAnalytics('validation--submit');
                    apSwitchStep('thank-you');
                    apAnalytics('confirmation--start');
                }

                toolLoader(true);
            },
        });
    });
}
